import BasicText from "./BasicText";
export default BasicText;
